import { render, staticRenderFns } from "./MinisiteFooter.vue?vue&type=template&id=ea1a4f6e"
import script from "./MinisiteFooter.vue?vue&type=script&lang=js"
export * from "./MinisiteFooter.vue?vue&type=script&lang=js"
import style0 from "./MinisiteFooter.vue?vue&type=style&index=0&id=ea1a4f6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports